module.exports = __webpack_public_path__ + "img/SKWINKELNetActieGeschenken5FA7C4.1b306e10.png";